<div *ngIf="_data" class="{{isPaddingLeft ? 'padLeft ': 'nonpadLeft'}}">
  <DropdownMenu
    [_DATA]="_sendData"
    [selectDataKey]="'key'"
    [displayNameKey]="'name'"
    [prefixIcon]=false
    [centeredText]=true
    [componentWidthStretch]=true
    (selectedItem)="oddTypeSelectHandler($event.key)">
  </DropdownMenu>
  <div class="oddText">
    <div class="oddItem_" *ngIf="isPaddingLeft"></div>
    <div class="oddItem_" *ngFor="let item of _ODD_TEXT_ITEMS">{{_translationHelper.transformTranslate(item)}}</div>
  </div>
</div>
